module.exports = __webpack_public_path__ + "static/media/LCD_4.5b44b6c1.svg";